import { render } from "./workflowcard-add.vue?vue&type=template&id=c454f266"
import script from "./workflowcard-add.vue?vue&type=script&lang=js"
export * from "./workflowcard-add.vue?vue&type=script&lang=js"

import "./workflowcard-add.vue?vue&type=style&index=0&id=c454f266&lang=css"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__